import { render, staticRenderFns } from "./BindsDialogPrompt.vue?vue&type=template&id=5284a76e&"
import script from "./BindsDialogPrompt.vue?vue&type=script&lang=js&"
export * from "./BindsDialogPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports